<template>
	<div>
		<div class="spinner-border" v-if="loader" style="margin:auto;display:block;margin-top:60px"/>
		<div class="col-sm-12 row" v-else>
			<div class="col-sm-11">
				<div v-on:submit.prevent>
					<div
						class="row"
						style="border-bottom: 2px solid #115E67;margin-bottom: 10px;font-size: 20px;padding: 5px 0px 0px 5px;"
						v-if="clientData && clientData.client_name"
					>
						<label style="margin: 0px;">{{clientData.client_name}}</label>
					</div>
					<div style="border:1px #d4d4d4 solid; padding:20px">
						<!-- <div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">Client Name</label>
							<label
								class="col-sm-10 pr-5"
								v-if="clientData.client_name"
								style="padding-top: calc(.375rem + 1px);"
							>{{clientData.client_name}}</label>
							<label
								class="col-sm-10 pr-5"
								v-else
								style="padding-top: calc(.375rem + 1px);color:red"
							>Not Provided</label>
						</div> -->
						<!-- <div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">Tagging Coverage</label>
							<label
								v-if="tagDefinition"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>
								<div v-if="totalCampaigns > 0">
									<span style="font-weight: bold;">Campaign {{taggedCampaigns}}/{{totalCampaigns}}</span>
									<div class="progress">
										<div class="progress-bar" role="progressbar" :style="`width: ${campaignCoverage}%; background-color: ${getCoverageColor(campaignCoverage)}`" aria-valuenow=dsp aria-valuemin="0" aria-valuemax="100">{{campaignCoverage}}%</div>
									</div>
								</div>
								<div v-if="totalDsp > 0">
									<span style="font-weight: bold;">DSP {{taggedDsp}}/{{totalDsp}}</span>
									<div class="progress">
										<div class="progress-bar" role="progressbar" :style="`width: ${dspCoverage}%; background-color: ${getCoverageColor(dspCoverage)}`" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">{{dspCoverage}}%</div>
									</div>
								</div>
								<div v-if="totalProducts > 0">
									<span style="font-weight: bold;">Product {{taggedProducts}}/{{totalProducts}}</span>
									<div class="progress">
										<div class="progress-bar" role="progressbar" :style="`width: ${productCoverage}%; background-color: ${getCoverageColor(productCoverage)}`" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100">{{productCoverage}}%</div>
									</div>
								</div>
							</label>
						</div> -->
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">Tag Type Definition</label>
							<label
								v-if="tagDefinition"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>
							<div>
								<span style="color: #2F5BC2; font-weight: bold;">Brand </span>
								<span v-if="!editMode">{{brandDef}}</span>
								<textarea v-else type="text" 
								class="form-control multi-dropdown col-md-12 select_filter"
								v-model="brandDef"
								placeholder="Add or modify brand tag definition after discussing tag strategy with the account team"
								></textarea>
							</div>
							<div>
								<span style="color: #1C919E; font-weight: bold;">Category </span>
								<span v-if="!editMode">{{categoryDef}}</span>
								<textarea v-else
								class="form-control multi-dropdown col-md-12 select_filter"
								v-model="categoryDef"
								placeholder="Add or modify category tag definition after discussing tag strategy with the account team"
								></textarea>
							</div>
							<div>
								<span style="color: #D98F34; font-weight: bold;">Sub-Category </span>
								<span v-if="!editMode">{{subcategoryDef}}</span>
								<textarea v-else
								class="form-control multi-dropdown col-md-12 select_filter"
								v-model="subcategoryDef"
								placeholder="Add or modify sub-category tag definition after discussing tag strategy with the account team"
								></textarea>
							</div>
						
							</label>
							<label
								v-else
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">Current Tags</label>
							<div class="col-sm-10 pr-5 align-self-center label-value-wrapper-style">
								<div style="break-inside: avoid;" class="btn tag-button brand"
								:title="'Brand: ' + tag.title"
								v-for="tag of allBrandTags">
									[{{ tag.types.toString() }}] {{ tag.title }}
								</div>
								<div style="break-inside: avoid;" class="btn tag-button cat"
								:title="'Category: ' + tag.title"
								 v-for="tag of allCategoryTags">
									[{{ tag.types.toString() }}] {{ tag.title }}
								</div>
								<div style="break-inside: avoid;" class="btn tag-button subcat"
								:title="'Sub-Category: ' + tag.title"
								 v-for="tag of allSubcategoryTags">
									[{{ tag.types.toString() }}] {{ tag.title }}
								</div>
							</div>
						</div>
						<!-- <div class="label label-info tag_label brand"
						:title="'Brand (' + tag.types.join(', ') + '): ' + tag.title"
						v-for="tag of 
						[
							...formatTags(item, ['campaign_brand','brand_product','brand'], 'Brand'),
						]">
							{{`[${tag.types.join(', ')}] ${tag.title}`}}
						</div>
						<div class="label label-info tag_label cat"
						:title="'Category (' + tag.types.join(', ') + '): ' + tag.title"
						v-for="tag of 
						[
							...formatTags(item, ['campaign_category','category_product','product_category'], 'Category'),
						]">
							{{`[${tag.types.join(', ')}] ${tag.title}`}}
						</div>
						<div class="label label-info tag_label subcat"
						:title="'Sub-Category (' + tag.types.join(', ') + '): ' + tag.title"
						v-for="tag of 
						[
						...formatTags(item, ['campaign_subcategory','sub_category_product','subcategory'], 'Sub-Cat')
						]">
							{{`[${tag.types.join(', ')}] ${tag.title}`}}
						</div> -->
						<!-- <div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">Brand Options</label>
							<div v-if="brandTagsList && editMode" style="display: inline-block; width: 80%;">
								<button 
								:style="deleteTagsList.includes(tag) ? `text-decoration: line-through; background-color: red;` : 'background-color: #2F5BC2;'"
								v-for="tag of brandTagsList"
								@click="deleteTag(tag)" class="btn tag-button">
									{{tag.title}}
								</button>
								<button 
								v-for="tag of newTagsList.filter(tag => tag.type.toLowerCase() === 'brand')" 
								style="background-color: green;"
								@click="removeTag(tag)" class="btn tag-button">
									{{tag.title}} *
								</button>
							</div>
							<label
								v-if="brandTagsList && !editMode"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>{{brandTagsList.map(tag => tag.title)}}</label>
							<label
							v-if="!editMode && !brandTagsList"
							class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row campaign-tags-add" v-if="editMode">
							<label for="tags" class="col-sm-2 col-form-label text-right">Add New Brand Option</label>
							<div style="width: 40%;">
								<input type="text" 
								v-model="brandTag"
								class="form-control multi-dropdown col-md-12 select_filter"
								placeholder="Add a new brand tag"
								@keyup.enter="addBrandTag"
								></input>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">Category Options</label>
							<div v-if="categoryTagsList && editMode" style="display: inline-block; width: 80%;">
								<button type="button"
								:style="deleteTagsList.includes(tag) ? `text-decoration: line-through; background-color: red;` : 'background-color: #1C919E;'"
								v-for="tag of categoryTagsList"
								@click="deleteTag(tag)" class="btn tag-button">
									{{tag.title}}
								</button>
								<button type="button"
								v-for="tag of newTagsList.filter(tag => tag.type.toLowerCase() === 'category')" 
								style="background-color: green;"
								@click="removeTag(tag)" class="btn tag-button">
									{{tag.title}} *
								</button>
							</div>
							<label
								v-if="categoryTagsList && !editMode"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>{{categoryTagsList.map(tag => tag.title)}}</label>
							<label
							v-if="!categoryTagsList && !editMode"
							class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row campaign-tags-add" v-if="editMode">
							<label for="tags" class="col-sm-2 col-form-label text-right">Add New Category Option</label>
							<div style="width: 40%;">
								<input type="text" 
								v-model="categoryTag"
								class="form-control multi-dropdown col-md-12 select_filter"
								placeholder="Add a new category tag"
								@keyup.enter="addCategoryTag"
								></input>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">Sub-Category Options</label>
							<div v-if="subcategoryTagsList && editMode"  style="display: inline-block; width: 80%;">
								<button type="button"
								:style="deleteTagsList.includes(tag) ? `text-decoration: line-through; background-color: red;` : 'background-color: #D98F34;'"
								v-for="tag of subcategoryTagsList"
								@click="deleteTag(tag)" class="btn tag-button">
									{{tag.title}}
								</button>
								<button type="button"
								v-for="tag of newTagsList.filter(tag => tag.type.toLowerCase() === 'subcategory')" 
								style="background-color: green;"
								@click="removeTag(tag)" class="btn tag-button">
									{{tag.title}} *
								</button>
							</div>
							<label
								v-if="subcategoryTagsList && !editMode"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>{{subcategoryTagsList.map(tag => tag.title)}}</label>
							<label
							v-if="!subcategoryTagsList && !editMode"
							class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row campaign-tags-add" v-if="editMode">
							<label for="tags" class="col-sm-2 col-form-label text-right">Add Sub-Category Option</label>
							<div style="width: 40%;">
								<input type="text" 
								v-model="subcategoryTag"
								class="form-control multi-dropdown col-md-12 select_filter"
								placeholder="Add a new sub-category tag"
								@keyup.enter="addSubcategoryTag"
								></input>
							</div>
          				</div>  -->
						<div class="form-group row">
							<button type="button" class="btn btn-secondary" @click="cancelHandler()">{{editMode ? 'Cancel': 'Back'}}</button>
							<button type="button" class="btn btn-primary" @click="saveHandler()">{{editMode ? 'Save': 'Edit'}}</button>
						</div>
					</div>		
				</div>
			</div>
		</div>
		<ListNamesPopUp
			ref="listPopUp"
			:namesArray="details"
			:type="type"
			:clientName="name"
			:showSpinner="fetchingItem"
		/>
	</div>
</template>

<script>
	import moment from "moment";
	import Multiselect from "vue-multiselect";
	import ListNamesPopUp from "@/components/account-management/ListNamesPopUp.vue";
	import AdAccountView from "@/components/account-management/AdAccountView.vue"
	import SellerView from "@/components/account-management/SellerView.vue"
	import VendorView from "@/components/account-management/VendorView.vue"
	import InstacartView from "@/components/account-management/InstacartView"
	import DSPView from "@/components/account-management/DSPView"
	import AMCView from "@/components/account-management/AMCView.vue";
	const formatCurrency = require("format-currency");

	export default {
		name: "Detail",
		data() {
			return {
				dataList: [],
				loader: false,
				clientData: {
					client: {},
					client_name: "",
					client_main_contact: "",
					go_ops: "",
					go_marketing: "",
					go_retail: "",
					partner_uuid:"",
					sharepoint_link:""
				},
				vendorData: [],
				sellerData: [],
				profileData: [],
				vendorList: [],
				amcList: [],
				type: "",
				details: [],
				name: "",
				fetchingItem: false,
				brandTag: "",
				brandTagsList: [],
				categoryTag: "",
				categoryTagsList: [],
				subcategoryTag: "",
				subcategoryTagsList: [],
				newTagsList: [],
				deleteTagsList: [],
				editMode: false,
				allBrandTags: [],
				allCategoryTags: [],
				allSubcategoryTags: [],
				tagDefinition: [],
				brandDef: '',
				categoryDef: '',
				subcategoryDef: '',
				dspCoverage: 0,
				totalDSP: 0,
				campaignCoverage: 0,
				totalCampaigns: 0,
				taggedCampaigns: 0,
				productCoverage: 0,
				totalProducts: 0,
				taggedProducts: 0,
			};
		},
		props: ["clientId", "profileId"],
		components: {
			moment,
			ListNamesPopUp,
			AdAccountView,
			SellerView,
			VendorView,
			InstacartView,
			DSPView,
			AMCView,
			Multiselect
		},
		mounted() {
			this.$store.dispatch("callAnalytics", {data:window.location.href, this:this, type:'AccountDetails'})

			let vm = this;
			if (this.clientId) {
				this.getClientData();
			} else if (this.profileId) {
				this.getProfileData();
			}

			this.$store.dispatch("getAccountVendors").then(res => {
				vm.vendorList = res.filter(e => e.vendor_name);
			});
			
			this.getTags()

			this.$store.dispatch("accounts/getAllTaggingStrategy", {client_id : this.clientId}).then(res => {
				const accountData = res[0]
				
				this.allBrandTags = [...(accountData.tags_seller || []), ...(accountData.tags_vendor || []), ...(accountData.tags_campaign || []), ...(accountData.tags_dsp || [])]
				.filter(t => ['brand', 'brand_product', 'campaign_brand'].includes(t.type))

				this.allBrandTags = this.formatTags(this.allBrandTags)

				this.allCategoryTags = [...(accountData.tags_seller || []), ...(accountData.tags_vendor || []), ...(accountData.tags_campaign || []), ...(accountData.tags_dsp || [])]
				.filter(t => ['product_category', 'category_product', 'campaign_category'].includes(t.type))

				this.allCategoryTags = this.formatTags(this.allCategoryTags)

				this.allSubcategoryTags = [...(accountData.tags_seller || []), ...(accountData.tags_vendor || []), ...(accountData.tags_campaign || []), ...(accountData.tags_dsp || [])]
				.filter(t => ['subcategory', 'sub_category_product', 'campaign_subcategory'].includes(t.type))

				this.allSubcategoryTags = this.formatTags(this.allSubcategoryTags)

				this.brandDef = (accountData.tags_strategy || []).filter(t => t.type === 'brand_def').map(t=>t.title).join(', ')

				this.categoryDef = (accountData.tags_strategy || []).filter(t => t.type === 'category_def').map(t=>t.title).join(', ')

				this.subcategoryDef = (accountData.tags_strategy || []).filter(t => t.type === 'subcategory_def').map(t=>t.title).join(', ')
			})

			this.$store.dispatch("accounts/getAccountTagCoverage", {client_ids : [this.clientId]}).then(res => {
				const accountData = res[0]
				// console.log('TAG COVERAGE: ',res)
				this.totalCampaigns = +accountData.client_camp_count
				this.taggedCampaigns = +accountData.client_tagged_camp_count
				this.campaignCoverage = Math.floor(this.taggedCampaigns / this.totalCampaigns * 100)

				this.totalProducts = +accountData.vendor_prod_count + +accountData.seller_prod_count
				this.taggedProducts = +accountData.client_tagged_vp + +accountData.client_tagged_sp
				this.productCoverage = Math.floor(this.taggedProducts / this.totalProducts * 100)

				this.totalDsp = +accountData.dsp_count
				this.taggedDsp = accountData.client_tagged_dsp
				this.dspCoverage = Math.floor(this.taggedDsp / this.totalDsp * 100)
			})


		},
		methods: {
			formatTags(tagList){

				const tagMap = {}
				for (const tag of (tagList || []).filter(t => ['brand','product_category', 'subcategory'].includes(t.type))){
					tag.title = tag.title.trim()
					tagMap[tag.title] = tagMap[tag.title] ?  tagMap[tag.title].concat(['DSP']) : ['DSP']
				}
				for (const tag of (tagList || []).filter(t => ['brand_product','category_product', 'sub_category_product'].includes(t.type))){
					tag.title = tag.title.trim()
					tagMap[tag.title] = tagMap[tag.title] ?  tagMap[tag.title].concat(['P']) : ['P']
				}
				for (const tag of (tagList || []).filter(t => ['campaign_brand','campaign_category', 'campaign_subcategory'].includes(t.type))){
					tag.title = tag.title.trim()
					tagMap[tag.title] = tagMap[tag.title] ?  tagMap[tag.title].concat(['SA']) : ['SA']
				}

				const tagsArray = []
				for (const key in tagMap){
					// tagsArray.push(`${key} (${[...new Set(tagMap[key])].join(', ')})`)
					tagsArray.push({title: key, types:[...new Set(tagMap[key])]})
				}

				return tagsArray
			},
			getCoverageColor(coveragePercentage){
				if (coveragePercentage > 90) {
					return 'green'
				} else if (coveragePercentage > 50) {
					return 'orange'
				} else {
					return 'red'
				}
			},
			openLinkInNewTab(url){
				window.open(url)
			},
			viewListPopUp(type, profile) {
				const vm = this;
				this.type = type.charAt(0).toUpperCase() + type.slice(1);
				this.name = profile.customName;
				this.fetchingItem = true;
				this.$refs["listPopUp"].openPopUp();
				this.details = []
				this.$store
					.dispatch("accounts/getSellerVendorDetailForProfile", {
						type: type,
						profileId: profile.profile_id
					})
					.then(resp => {
						vm.details.push(resp);
						vm.fetchingItem = false;
					});
			},
			parseData(data) {
				let type = [];
				if (data.marketing_campaign_sp == true) {
					type.push("SP");
				}
				if (data.marketing_campaign_sb == true) {
					type.push("SB");
				}
				if (data.marketing_campaign_sd == true) {
					type.push("SD");
				}

				return type.join(", ");
			},
			rowDataFilter(arr) {
				let key = arr[0];
				let val = arr[1];

				let obj = {};
				obj[key] = val;
				this.dataList.push(obj);
			},
			parse(data) {
				let key = data.split("_");
				return key.join(" ");
			},
			parsedContacts(data) {
				let str = "";
				if (data) {
					if (data.first_name) {
						str = data.first_name;
					}
					if (data.last_name) {
						str = str + " " + data.last_name;
					}
				}
				return str;
			},
			getFormattedDate(date) {
				
				return  moment(date).format("MM/DD/YYYY");
			},
			getClientData() {
				let vm = this
				this.loader = true
				this.$store.dispatch("accounts/getAccountSections",{go_client_id:this.clientId}).then(res=>{
					vm.loader = false
					vm.clientData = res.clientData;
					let profiles = (res && res.profileData && res.profileData.length) ? res.profileData : [];
					vm.profileData = profiles.map(item => {
						if(item && item.type=='Ad Accounts'){
							item['monthly_budget'] = this.formatDailyBudget(item['monthly_budget']||0)
							let name = item.name
								? item.name + " ("
								: "";
							name =
								name +
								item.brand_entity_id +
								(item.name ? ")" : "");
							item["customName"] = name;
						}
						return item;
					});
					vm.showProfileInfo = true;
				})
			},
			getProfileData() {
				this.loader = true;
				let vm = this;
				this.$store
					.dispatch("accounts/getVendorDataById", {
						profile_id: this.profileId
					})
					.then(res => {
						vm.loader = false;
						vm.profileData.push(res);
					});
			},
			showProfileVendor(data) {
				let vendor = this.vendorList.find(e => e.vendor_id == data);
				return vendor ? vendor.vendor_name : "";
			},
			formatDailyBudget(num) {
				var num = formatCurrency(num);
				return num;
			},
			addBrandTag(){
				console.log(this.brandTag)
				const newTag = {title: this.brandTag.toLowerCase(), type: 'brand'}

				if ([...this.newTagsList, ...this.brandTagsList].map(t=>t.title.trim().toLowerCase()).includes(newTag.title)) {
					return
				}

				this.newTagsList.push(newTag)
			},
			selectBrandTag(data){
				
			},
			addCategoryTag(){
				const newTag = {title: this.categoryTag.toLowerCase(), type: 'category'}

				if ([...this.newTagsList, ...this.categoryTagsList].map(t=>t.title.trim().toLowerCase()).includes(newTag.title)) {
					return
				}

				this.newTagsList.push(newTag)
			},
			selectCategoryTag(data){

			},
			addSubcategoryTag(data){
				const newTag = {title: this.subcategoryTag.toLowerCase().trim(), type: 'subcategory'}

				if ([...this.newTagsList, ...this.subcategoryTagsList].map(t=>t.title.trim().toLowerCase()).includes(newTag.title)) {
					return
				}

				this.newTagsList.push(newTag)
			},
			selectSubcategoryTag(data){

			},
			getTags(){
				this.$store.dispatch("accounts/getTaggingStrategy", {client_id: this.clientId}).then(res => {
					this.brandTagsList = res.filter(tag => tag.type.toLowerCase() === 'brand')
					this.categoryTagsList = res.filter(tag => tag.type.toLowerCase() === 'category')
					this.subcategoryTagsList = res.filter(tag => tag.type.toLowerCase() === 'subcategory')
					this.tagDefinition = res.filter(tag => ['brand_def','subcategory_def','category_def'].includes(tag.type.toLowerCase()))
				})
			},
			async saveHandler() {
				console.log('clientId: ', this.clientId)
				console.log('saveTags: ', this.newTagsList)

				if (!this.editMode) {
					this.editMode = true
					return
				}

				this.deleteTagsList = [...this.deleteTagsList, ...this.tagDefinition]
				if (this.brandDef) {
					this.newTagsList.push({title: this.brandDef, type: 'brand_def'})
				}
				if (this.categoryDef) {
					this.newTagsList.push({title: this.categoryDef, type: 'category_def'})
				}				
				if (this.subcategoryDef) {
					this.newTagsList.push({title: this.subcategoryDef, type: 'subcategory_def'})
				}
				if (this.deleteTagsList.length) {
					await this.$store.dispatch("accounts/deleteTaggingStrategy", {tags: this.deleteTagsList, client_id: this.clientId})
					this.deleteTagsList = []
				}
				if (this.newTagsList.length) {
					const res = await this.$store.dispatch("accounts/setTaggingStrategy", {tags: this.newTagsList, client_id: this.clientId})
					this.brandTagsList = res.filter(tag => tag.type.toLowerCase() === 'brand')
					this.categoryTagsList = res.filter(tag => tag.type.toLowerCase() === 'category')
					this.subcategoryTagsList = res.filter(tag => tag.type.toLowerCase() === 'subcategory')
					this.newTagsList = []
				}

				await this.getTags()
				this.editMode = false

			},
			cancelHandler() {
				if (!this.editMode){
					this.$router.back()
				}
				this.editMode = false
				this.newTagsList = []
				this.deleteTagsList = []
				this.brandTag = ''
				this.subcategoryTag = ''
				this.categoryTag = ''
			},
			removeTag(data){ 
				console.log(data)
				// this.categoryTagsList = this.categoryTagsList.filter( tag => tag !== data)
				this.newTagsList = this.newTagsList.filter( tag => tag !== data)
			},
			deleteTag(data){ 
				// this.categoryTagsList = this.categoryTagsList.filter( tag => tag !== data)
				if (this.deleteTagsList.includes(data)) {
					this.deleteTagsList = this.deleteTagsList.filter( tag => tag !== data)
				} else {
					this.deleteTagsList.push(data)
				}
				console.log('deleteTagsList: ', this.deleteTagsList)
			}
		}
	};
</script>

<style lang="scss">
.label-wrapper-style {
	color: #888888;
}
.label-value-wrapper-style {
	margin: 0px;
}
.label-not-provided-wrapper {
	color: #e1dfdf;
}
.capital {
	text-transform: capitalize !important
}
.tag-button {
	color: #fff;
	background-color: #888888;
}
.tag_label{
	display: inline-block !important; 
	padding: 5px !important; 
	margin: 2px !important; 
	max-width:calc(100%) !important; 
	text-overflow: ellipsis !important; 
	white-space: nowrap !important; 
	overflow: hidden !important;
}
.brand{
	background-color: #2F5BC2 !important;
}
.cat{
	background-color: #1C919E !important;
}
.subcat{
	background-color: #D98F34 !important;
}
</style>
